export default "/static/89543e3a3754d3a7.svg"